import Keycloak from 'keycloak-js'
const keycloakConfig = {
   url: process.env.REACT_APP_KEYCLOAK, 
   realm: 'codikett', 
   clientId: 'core_web'
}
const keycloakProviderInitConfig = {
  onLoad: 'login-required',
  responseMode: 'query', 
  checkLoginIframe: false
}
const keycloak = new Keycloak(keycloakConfig);
export {keycloak, keycloakProviderInitConfig}